import { Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class SwUpdateService {
  constructor(
    private swUpdate: SwUpdate,
    private toastr: ToastrService
  ) {}

  public checkForUpdates(): void {
    if (!this.swUpdate.isEnabled) {
      console.log('Service Worker is not enabled');
      return;
    }

    // Check for updates immediately
    this.swUpdate.checkForUpdate().then(updateAvailable => {
      if (updateAvailable) {
        console.log('Update check: Update is available');
      }
    });

    // Listen for version updates
    this.swUpdate.versionUpdates
      .pipe(
        filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
      )
      .subscribe(() => {
        console.log('New version available');
        this.showUpdateNotification();
      });

    // Check for unrecoverable state
    this.swUpdate.unrecoverable.subscribe(event => {
      console.error('Unrecoverable state:', event.reason);
      this.toastr.error(
        'De applicatie moet opnieuw worden geladen',
        'Fout',
        {
          disableTimeOut: true,
          closeButton: true
        }
      );
    });
  }

  private showUpdateNotification(): void {
    const message = `
      <div style="display: flex; flex-direction: column; gap: 12px;">
        <div>Er is een nieuwe frontend versie beschikbaar</div>
        <button
          id="reload-app-btn"
          style="
            background-color: #3b82f6;
            color: white;
            padding: 8px 16px;
            border-radius: 6px;
            border: none;
            cursor: pointer;
            font-weight: 500;
            transition: background-color 0.2s;
          "
          onmouseover="this.style.backgroundColor='#2563eb'"
          onmouseout="this.style.backgroundColor='#3b82f6'"
        >
          Herladen
        </button>
      </div>
    `;

    const toastRef = this.toastr.info(
      message,
      'Update beschikbaar',
      {
        enableHtml: true,
        disableTimeOut: true,
        closeButton: true,
        tapToDismiss: false,
        positionClass: 'toast-top-right',
        toastClass: 'ngx-toastr'
      }
    );

    // Add click listener to the button after toast is rendered
    if (toastRef) {
      setTimeout(() => {
        const reloadBtn = document.getElementById('reload-app-btn');
        if (reloadBtn) {
          reloadBtn.addEventListener('click', () => {
            this.reloadApplication();
          });
        }
      }, 100);
    }
  }

  private reloadApplication(): void {
    this.swUpdate.activateUpdate().then(() => {
      window.location.reload();
    });
  }
}
